<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useCallStore} from "../../../store/calls"
import {useModalStore} from "../../../store/modal"
import {useUserStore} from "../../../store/users"
import {computed, onMounted, ref} from "vue";
import {useAuthStore} from "../../../store/auth"

const loading = ref(false)
const callStore = useCallStore()
const modalStore = useModalStore()
const userStore = useUserStore()
const is_assigned = ref(false)
const callIds = computed(() => modalStore.props.call_ids || [])
const callCount = computed(() => callIds.value.length)
const users = ref([])
const options = ref([])
const assigned_user = ref()
const authStore = useAuthStore()
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin', 'internal-team-leader'].includes(authStore.user.roles[0].name))

const heading = computed(() => {
    if (is_assigned.value) {
        return `${callCount.value} call(s) assigned.`
    } else {
        return `Assign ${callCount.value} call(s).`
    }
})

const description = computed(() =>
    is_assigned.value
        ? `Assigned to ${users.value.find(u => u.id === assigned_user.value)?.first_name || ''}`
        : `Select an assignee for ${callCount.value} call(s)`
)

const assignCalls = async () => {
    loading.value = true
    try {
        await callStore.bulkAssignCalls(callIds.value, assigned_user.value)
        is_assigned.value = true
        // Refresh the calls list
        await callStore.getCalls({
            sort_direction: 'desc',
            limit: 25,
            page: 1
        })
    } catch (error) {
        console.error('Error assigning calls:', error)
    } finally {
        loading.value = false
    }
}

onMounted(async () => {
    loading.value = true
    await userStore.getAllUsers({all: false, role: 'internal-agent'});
    users.value = isAdmin.value ? userStore.users : [authStore.user]

    options.value = users.value.map(u => ({
        value: u.id,
        label: `${u.first_name} ${u.last_name}`
    }))
    loading.value = false
})
</script>

<template>
<DefaultModalBase :description="description" :heading="heading" :icon="is_assigned ? 'check-all' : 'user-single-add'" :loading="loading" :refresh="is_assigned">

    <div class="call-assign-container">
        <brand-button variant="secondary" v-if="is_assigned" @click="modalStore.close(true)">Done</brand-button>
        <brand-form-select label="Assign to." :options="options" v-model="assigned_user" v-if="!is_assigned"/>
        <brand-button @click="assignCalls()" :disabled="!assigned_user" v-if="!is_assigned">Assign {{ callCount }} call(s)</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>

